module.exports = __webpack_public_path__ + "2cd49bf6bb0fd7ea8031b932709d49a8.svg";